<app-section01 [data]="data.SECTION01"></app-section01>
<app-section02 [data]="data.SECTION02"></app-section02>
<app-section03 [data]="data.SECTION03"></app-section03>
<app-section04 [data]="data.SECTION04"></app-section04>
<app-section05 [data]="data.SECTION05"></app-section05>
<app-section06 [data]="data.SECTION06"></app-section06>
<app-section07 [data]="data.SECTION07"></app-section07>
<app-section08 [data]="data.SECTION08"></app-section08>